import ApiService from "@/services/api.service";
import { UserService } from "@/services/user.service";

class FetchingError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const MembersService = {
    fetchMembers: async function() {
        // const user_roles = UserService.getUserData('user_roles').split(";");
        const requestData = {
            method: 'post',
            url: "/p/members",
            data: {
                // user_roles: user_roles,
                user_id: UserService.getUserData('user_id')
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.members
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    fetchMember: async function (member_id) {
        const requestData = {
            method: 'post',
            url: "/p/member",
            data: {
                user_id: UserService.getUserData('user_id'),
                member_id: member_id
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data;
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    saveMember: async function (data) {
        // console.log(data);
        // alert(data);
        const requestData = {
            method: 'post',
            url: "/p/save_member",
            data: {
                member_data: data
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data;
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    uploadUserImage: async function (data) {
        // console.log(data);
        // alert(data);
        ApiService.setUploadHeader();
        try {
            // for (var p of data) {
            //     console.log(p);
            // }
            const response = await ApiService.post('/p/upload_image', data)
            ApiService.setHeader()

            return response.data;
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
}

export default MembersService

export { MembersService, FetchingError }